module.exports = __webpack_public_path__ + "media/images/meta/digi-wedding-53d3c05d51dd22ac601675a96d019772.png";